import { render, staticRenderFns } from "./Lotto.vue?vue&type=template&id=61a8a1fc&scoped=true&lang=pug"
import script from "./Lotto.vue?vue&type=script&lang=js"
export * from "./Lotto.vue?vue&type=script&lang=js"
import style0 from "./Lotto.vue?vue&type=style&index=0&id=61a8a1fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a8a1fc",
  null
  
)

export default component.exports